import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, } from 'react-accessible-accordion';

import { FeedingController } from '../controllers/Feeding';


export const FeedingResults = class Form extends Component {
  constructor() {
    super();
    this.state = {
      selected_menu: {},
      results: false,
      smart_feeding_message: null,
      food_group_deficiency: [],
      response: {
        error: null,
        warning: null,
        problem: null,
        message: null,
        success: false,
        gpt: ''
      }
    };
  }

  onChange = (e) => {
    const state = this.state;
    const value = e.target.value;
    const name = e.target.name;
    const selected_menu_keys = Object.keys(state.selected_menu);
    if (state.selected_menu[name] === value) {
      e.target.checked = false;
      delete state.selected_menu[name];
    }
    else
      state.selected_menu[name] = value;

    this.setState(state);
  }

  onSubmit = (e) => {
    const { selected_menu } = this.state;
    const { deficiency_food_groups_menu, food_groups_ids, gpt } = this.props.response;
    const { feeding_options } = this.props;
    const translation = this.props.Translator;

    const selected_groups_keys = Object.keys(selected_menu);
    const selected_groups = selected_groups_keys.length;
    const required_groups = 4 - food_groups_ids.length;

    const menu_data = [];

    if (selected_groups === 0) {
      if (translation['language'] == 'swahili')
        alert("Tafadhali, chagua chakula");
      else
        alert("Please, select food item(s)");
      return;
    }
    else if (selected_groups < (required_groups) || selected_groups > (required_groups)) {
      if (translation['language'] == 'swahili')
        alert("Unatakiwa kuchagua makundi " + required_groups + " ya vyakula");
      else
        alert("You are supposed to select " + required_groups + " food groups");
      return;
    }
    else {
      let menu_ids = [];
      selected_groups_keys.forEach((key) => {
        menu_ids.push(selected_menu[key]);
      })
      deficiency_food_groups_menu.forEach((group_menu) => {
        group_menu['group_menu'].forEach((menu) => {
          if (menu_ids.includes(menu['food_id'])) {
            menu_data.push({ label: menu['food_name'], value: menu['food_id'] });
          }
        })
      })
      let results = FeedingController.getSmartFeedingMenu(menu_data, feeding_options.breast_feeding, this.props.Child, this.props.age, this.props.Translator);
      this.setState({ smart_feeding_message: results, results: true });
    }
  }

  getFoodGroupsData = () => {
    const { Translator } = this.props;
    const translation = Translator;
    const { deficiency_food_groups_menu, food_groups_ids } = this.props.response;

    var food_group_deficiency = [];

    var c = 1;
    if (food_groups_ids.length < 4) {
      if (translation['language'] == 'swahili') {

        var group_no = 1;
        deficiency_food_groups_menu.forEach((group_menu) => {

          var menu = { listA: [], listB: [] };
          var rand_indexes = [];
          var total_no = group_menu['group_menu'].length;

          for (let j = 0; j < total_no; j++) {
            let rand_index = Math.floor(Math.random() * total_no);

            //Check if random number has been repeated, if yes then find another number
            while (rand_indexes.includes(rand_index)) {
              rand_index = Math.floor(Math.random() * total_no);
            }

            rand_indexes.push(rand_index);

            let food = group_menu['group_menu'][rand_index];
            if (j <= 2)
              menu.listA.push(<li><input type='radio' onClick={this.onChange} value={food['food_id']} name={`group_manu${group_no}`} />{food['food_name_swahili']}</li>);
            else
              menu.listB.push(<li><input type='radio' onClick={this.onChange} value={food['food_id']} name={`group_manu${group_no}`} />{food['food_name_swahili']}</li>);


          }
          food_group_deficiency.push({
            group_name: c + ". " + group_menu['group_name_swahili'],
            menu: menu
          });

          c++;
          group_no++;
        });
      }
      else {

        var group_no = 1;
        deficiency_food_groups_menu.forEach((group_menu) => {

          var menu = { listA: [], listB: [] };
          var rand_indexes = [];
          var total_no = group_menu['group_menu'].length;

          for (let j = 0; j < total_no; j++) {
            let rand_index = Math.floor(Math.random() * total_no);

            //Check if random number has been repeated, if yes then find another number
            while (rand_indexes.includes(rand_index)) {
              rand_index = Math.floor(Math.random() * total_no);
            }

            rand_indexes.push(rand_index);

            let food = group_menu['group_menu'][rand_index];
            if (j <= 2)
              menu.listA.push(<li><input type='radio' onClick={this.onChange} value={food['food_id']} name={`group_manu${group_no}`} />{food['food_name']}</li>);
            else
              menu.listB.push(<li><input type='radio' onClick={this.onChange} value={food['food_id']} name={`group_manu${group_no}`} />{food['food_name']}</li>);


          }
          food_group_deficiency.push({
            group_name: c + ". " + group_menu['group_name'],
            menu: menu
          });

          c++;
          group_no++;
        });
      }

      this.setState({ food_group_deficiency: food_group_deficiency });
    }
  }

  componentDidMount() {
    this.getFoodGroupsData();
  }

  render() {
    const { Translator, Child } = this.props;
    const translation = Translator;
    const { C_firstname } = Child;
    const { gpt, feeding_message, feeding_warning, message_display, warning_display, deficiency_food_groups_menu, food_groups_deficiency_message, food_groups_ids } = this.props.response;
    const {
      total_energy, required_energy, total_protein,
      required_protein_max, required_protein_min, total_vitamin_A,
      total_vitamin_C, total_vitamin_D, total_vitamin_E,
      required_vitamin_A_max, required_vitamin_C_max,
      required_vitamin_D_max, required_vitamin_E_max,
      required_vitamin_A_min, required_vitamin_C_min,
      required_vitamin_D_min, required_vitamin_E_min,
    } = this.props.response.feeding_nutrients;

    const { food_group_deficiency } = this.state;

    return (
      <div className="col-sm-12 col-md-12 col-xs-12" id="food_messages" style={{ padding: "0px", height: "100%", overflowY: "scroll", overflowX: "hidden" }}>
        <div style={{ height: "100%" }}>
          <div className="row">
            <div style={{ width: "16.66666666666666%", float: "left" }}>
              <div className="form-group" style={{ border: "1px solid #fff" }}>
                <label style={{ padding: "0px 20px", fontSize: "0.6em", color: "hsl(120, 50%, 40%)" }}>{translation['feeding_practice_energy_lebel']}</label>
                <div style={{ padding: "5px 20px", fontSize: "0.7em", color: "#000", fontWeight: "bolder", borderTop: "1px solid #fff", height: "20px", overflowX: "scroll" }}>
                  {(total_energy >= (required_energy) && total_energy < (required_energy + (0.5 * required_energy))) ? (
                    <div style={{ color: "blue" }}>{total_energy}K_cal</div>
                  ) : (
                    <div style={{ color: "red" }}>{total_energy}K_cal</div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ width: "16.66666666666666%", float: "left" }}>
              <div className="form-group" style={{ border: "1px solid #fff", borderLeft: "0px" }}>
                <label style={{ paddingLeft: "10px", fontSize: "0.6em", color: "hsl(120, 50%, 40%)" }}>{translation['feeding_practice_protein_lebel']}</label>
                <div style={{ padding: "5px 10px", fontSize: "0.7em", color: "#000", fontWeight: "bolder", borderTop: "1px solid #fff", height: "20px" }}>
                  {(total_protein >= (required_protein_min) && total_protein <= (required_protein_max)) ? (
                    <div style={{ color: "blue" }}>{total_protein}g</div>
                  ) : (
                    <div style={{ color: "red" }}>{total_protein}g</div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ width: "16.66666666666666%", float: "left" }}>
              <div className="form-group" style={{ border: "1px solid #fff", borderLeft: "0px" }}>
                <label style={{ paddingLeft: "5px", fontSize: "0.6em", color: "hsl(120, 50%, 40%)" }}>{translation['feeding_practice_vitamin_lebel']} A</label>
                <div style={{ padding: "5px 10px", fontSize: "0.7em", color: "#000", fontWeight: "bolder", borderTop: "1px solid #fff", height: "20px" }}>
                  {(total_vitamin_A >= (required_vitamin_A_min) && total_vitamin_A <= (required_vitamin_A_max)) ? (
                    <div style={{ color: "blue" }}>{total_vitamin_A}g</div>
                  ) : (
                    <div style={{ color: "red" }}>{total_vitamin_A}g</div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ width: "16.66666666666666%", float: "left" }}>
              <div className="form-group" style={{ border: "1px solid #fff", borderLeft: "0px" }}>
                <label style={{ paddingLeft: "5px", fontSize: "0.6em", color: "hsl(120, 50%, 40%)" }}>{translation['feeding_practice_vitamin_lebel']} C</label>
                <div style={{ padding: "5px 10px", fontSize: "0.7em", color: "#000", fontWeight: "bolder", borderTop: "1px solid #fff", height: "20px" }}>
                  {(total_vitamin_C >= (required_vitamin_C_min) && total_vitamin_C <= (required_vitamin_C_max)) ? (
                    <div style={{ color: "blue" }}>{total_vitamin_C}g</div>
                  ) : (
                    <div style={{ color: "red" }}>{total_vitamin_C}g</div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ width: "16.66666666666666%", float: "left" }}>
              <div className="form-group" style={{ border: "1px solid #fff", borderLeft: "0px" }}>
                <label style={{ paddingLeft: "5px", fontSize: "0.6em", color: "hsl(120, 50%, 40%)" }}>{translation['feeding_practice_vitamin_lebel']} D</label>
                <div style={{ padding: "5px 10px", fontSize: "0.7em", color: "#000", fontWeight: "bolder", borderTop: "1px solid #fff", height: "20px" }}>
                  {(total_vitamin_D >= (required_vitamin_D_min) && total_vitamin_D <= (required_vitamin_D_max)) ? (
                    <div style={{ color: "blue" }}>{total_vitamin_D}g</div>
                  ) : (
                    <div style={{ color: "red" }}>{total_vitamin_D}g</div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ width: "16.66666666666666%", float: "left" }}>
              <div className="form-group" style={{ border: "1px solid #fff", borderLeft: "0px" }}>
                <label style={{ paddingLeft: "5px", fontSize: "0.6em", color: "hsl(120, 50%, 40%)" }}>{translation['feeding_practice_vitamin_lebel']} E</label>
                <div style={{ padding: "5px 10px", fontSize: "0.7em", color: "#000", fontWeight: "bolder", borderTop: "1px solid #fff", height: "20px" }}>
                  {(total_vitamin_E >= (required_vitamin_E_min) && total_vitamin_E <= (required_vitamin_E_max)) ? (
                    <div style={{ color: "blue" }}>{total_vitamin_E}g</div>
                  ) : (
                    <div style={{ color: "red" }}>{total_vitamin_E}g</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ wdth: "100%", borderBottom: "1px solid #fff" }}>
            <div className="col-md-6 col-sm-6 col-xs-6" style={{ width: "50%" }}>
              <div style={{ position: "relative", float: "left", width: "15px", height: "15px", background: "red", borderRadius: "50%", marginLeft: "10px", marginBottom: "5px" }}></div>
              <div style={{ position: "relative", float: "left", paddingLeft: "5px", fontSize: "0.8em" }}>{translation['feeding_practice_insufficient_nutrients_lebel']}</div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6" style={{ width: "50%" }}>
              <div style={{ position: "relative", float: "left", width: "15px", height: "15px", background: "blue", borderRadius: "50%", marginLeft: "10px", marginBottom: "5px" }}></div>
              <div style={{ position: "relative", float: "left", paddingLeft: "5px", fontSize: "0.8em" }}>{translation['feeding_practice_sufficient_nutrients_lebel']}</div>
            </div>
          </div>
          <div style={{ height: "300%", overflow: "scroll" }}>
            {this.state.results ? (
              <div className="col-xs-12 col-sm-12 col-md-12" style={{ paddingBottom: "20px", height: "auto", marginTop: "30px" }}>
                <div style={{ backgroundColor: "hsl(120, 50%, 40%)", padding: "10px", borderRadius: "4px" }}>{ReactHtmlParser(this.state.smart_feeding_message)}</div>
              </div>
            ) : (
              <div>

                <div id="breast_results" style={{ backgroundColor: "hsl(120, 50%, 40%)", color: "#000", padding: "20px", height: "auto", borderRadius: "5px", margin: "0px 5px" }}>
                  {gpt && gpt.split('\n').map((line, lineIndex) => (
                    <div key={`line-${lineIndex}`}>
                      {line.split(/\*\*(.*?)\*\*/).map((text, index) =>
                        index % 2 === 0 ? <>{text}<br/></> : <strong key={`bold-${lineIndex}-${index}`}>{text}</strong>
                      )}
                    </div>
                  ))}
                  <br/>
                  {/* {ReactHtmlParser(food_groups_deficiency_message)} */}
                  <br />
                  {
                    food_group_deficiency.map((food_group) => (
                      <div>
                        <div>
                          <b>
                            {food_group.group_name}
                          </b>
                        </div>
                        <div>
                          <ul style={{ listStyle: "none" }}>
                            {food_group.menu.listA.map((menu) => menu)}
                            <Accordion allowZeroExpanded={true}>
                              <AccordionItem>
                                <AccordionItemHeading>
                                  <AccordionItemButton>
                                    <button>{translation['language'] == 'swahili' ? "Vyakula zaidi" : "More"}</button>
                                  </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                  {food_group.menu.listB.map((menu) => menu)}
                                </AccordionItemPanel>
                              </AccordionItem>
                            </Accordion>

                          </ul>
                        </div>
                      </div>
                    ))
                  }
                  <div style={{ border: "0px" }}>
                    {
                      food_groups_ids.length < 4 ?
                        translation['language'] == 'swahili' ? (
                          <button style={{ height: "35px" }} onClick={this.onSubmit} >Pata mpangilio wa vyakula ulivyochagua</button>
                        ) : (
                          <button style={{ height: "35px" }} onClick={this.onSubmit} >Get a food combination of all food which you have selected</button>
                        )
                        : null
                    }
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}

export default FeedingResults;